export const FOOTER_TITLE_LABEL = 'Aircraft Management Software';
